import FeltoltesTesztlapTableService from 'app/admin/feltoltestesztlap/service/FeltoltesTesztlapTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import FeltoltesTesztlapDeleteButton from './FeltoltesTesztlapDeleteButton';
import FeltoltesTesztlapCloseButton from './FeltoltesTesztlapCloseButton';

const config = {
	key: 'feltoltesTesztlapTable',
	text: 'Feltöltés',
	textKey: 'uploadsheet',
	service: FeltoltesTesztlapTableService,
	icon: 'person',
	editFormState: item => `/feltoltestesztlap/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowButtonList: [
		{ key: 'close', component: FeltoltesTesztlapCloseButton, paperType: 'tesztlap_kepek' },
		{ key: 'delete', component: FeltoltesTesztlapDeleteButton, paperType: 'tesztlap_kepek' }
	],
	columns: [
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'szkenneltFilename',
			text: 'Fájl neve',
			textKey: 'szkenneltFilename',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'szkenneltPath',
			text: 'Útvonal',
			textKey: 'szkenneltPath',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function FeltoltesTesztlapTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('feltoltesTesztlapTable', reducer('feltoltesTesztlapTable'))(FeltoltesTesztlapTable);
